export default class LogsSelector {
  public static selectMessages(state: ReduxState): string[] {
    return state.log.messages;
  }
}
